module.exports = __webpack_public_path__ + "static/media/img_hand_shaking@2x.603a6ad5.png";